import { render, staticRenderFns } from "./CategoriesChallenges.vue?vue&type=template&id=0bd01df6&scoped=true"
import script from "./CategoriesChallenges.vue?vue&type=script&lang=ts"
export * from "./CategoriesChallenges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd01df6",
  null
  
)

export default component.exports